// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"d7515a5c","284":"ce0dfd42","453":"b8d6803b","576":"218809b7","907":"6620db18"}[chunkId] + ".chunk.js";
};